module.exports = __webpack_public_path__ + "img/regions_map.a38b9cf0.png";